import axios from "axios";
import {
  LOADING_STARTS,
  LOADING_STOPS,
} from "../../../services/types/LoadingTypes";
import { REGISTER_TURBO_URL } from "../../../services/apis/SignUpUrl";
import { toast } from "react-toastify";

export const Turboaction = (data, price, history) => async (dispatch) => {
  dispatch({
    type: LOADING_STARTS,
    payload: true,
  });

  const email = data.email;
  const phone_number = data.phoneNumber;
  const last_name = data.lastName;
  const first_name = data.firstName;
  const payment_option = data.payment_option;
  const Swal = require("sweetalert2");

  try {
    const response = await axios.post(`${REGISTER_TURBO_URL}`, data);
    if (response.data.id) {
      // toast.success("User registered");
      Swal.fire({
        title: "Successful!",
        text: "We have recieved your information. A member of our team will contact you very soon! Thank you.",
        icon: "success",
        confirmButtonColor: "#1ac9d8",
      });
      // .then(function () {
      //   window.location.replace("");
      // });

      if (price === "75000") {
        window.location.href = `https://paystack.com/pay/turbo-connect/?first_name=${first_name}&email=${email}&last_name=${last_name}&phone=${phone_number}`;
      } else {
        window.location.href = `https://paystack.com/pay/turbo-pro/?first_name=${first_name}&email=${email}&last_name=${last_name}&phone=${phone_number}`;
      }
      dispatch({
        type: LOADING_STOPS,
        payload: false,
      });
    }
  } catch (e) {
    if (e) {
      toast.error(e.response.data.message);

      dispatch({
        type: LOADING_STOPS,
        payload: false,
      });
    }
  }
};
